var Ractive = require('ractive');
var component = module;

  component.exports ={
    data:function() {
      return {           
          Meta: {
            Columns: []
          },
          Row: {},
          Lng: SiteLng
        }
    }
  }

component.exports.template = {v:4,t:[{p:[1,1,0],t:7,e:"form",m:[{n:"style",f:"margin-left: 5px; margin-right: 5px;",t:13}],f:[{t:4,f:[{t:4,f:[{p:[4,3,105],t:7,e:"Element-Input",m:[{n:"Meta",f:[{t:2,r:".",p:[4,23,125]}],t:13},{n:"value",f:[{t:2,x:{r:["format",".Name","Row",".Control"],s:"_0.Value(_2[_1],_3)"},p:[4,35,137]}],t:13}]}],n:50,r:".DetailVisible",p:[3,3,78]}],i:"c",r:"Meta.Columns",p:[2,3,55]}]}],e:{"_0.Value(_2[_1],_3)":function (_0,_1,_2,_3){return(_0.Value(_2[_1],_3));}}};
module.exports = Ractive.extend(component.exports);



//////////////////
// WEBPACK FOOTER
// ./~/ractive-component-loader!./ractive/Project/ERP/Element/DetailsSimple.html
// module id = 21
// module chunks = 0